export const subtitles = {
    "1": {
        "startTime": 1.04,
        "endTime": 3.85,
        "transcript": "Qanqernaurtukuk.",
        "translation": "Let's speak."
    },
    "2": {
        "startTime": 4.5600000000000005,
        "endTime": 10.41,
        "transcript": "Ii-i, tua-i imumi cumigyagutellemni-ll' wiinga",
        "translation": "Well, a long time ago, when I became observant"
    },
    "3": {
        "startTime": 11.2,
        "endTime": 18.98,
        "transcript": "Ellangamta tua-i maaten ellangukut tamakut-llu au͡g'um ava-i qanrutkellri aiparmi niiskengaqluki.",
        "translation": "When we were growing up, we realized that we would hear about what my spouse talked about when we were growing up."
    },
    "4": {
        "startTime": 18.985,
        "endTime": 25.315,
        "transcript": "Tau͡gaam tang tua-i wangkutni ayagyuani tua-i alingnaqluteng tamakut Kass'aqarraat.",
        "translation": "But for us young people, those first Caucasians were scary."
    },
    "5": {
        "startTime": 25.315,
        "endTime": 29.645,
        "transcript": "Qavcin tua-i Kass'at tangerqalaqeput.",
        "translation": "We would see several Caucasians."
    },
    "6": {
        "startTime": 30.175,
        "endTime": 37.425,
        "transcript": "Tangelguyugnaunani. Caqapkacagaqamta tekitellrianek Kass'anek tangerqaqluta.",
        "translation": "We didn't always see them. Only once in a blue moon, we would see Caucasians who arrived."
    },
    "7": {
        "startTime": 38.57,
        "endTime": 47.43,
        "transcript": "Tamakut tamaa-i. Tua-i-ll' piqerluteng maani Anuuraami uitaluta elitnaurvingluteng maani.",
        "translation": "There you have it. Then one day, we were here in Anuuraaq when they built a school here."
    },
    "8": {
        "startTime": 47.435,
        "endTime": 52.065,
        "transcript": "Takuk'acagamteńi elitnaurvingluteng, ayumian elitnaungluteng.",
        "translation": "They built a school in the middle of us, then they started going to school."
    },
    "9": {
        "startTime": 52.34,
        "endTime": 61.43,
        "transcript": "Tua-i-llu tua-i elitnauryassaagyaaqelriakut, tamakut angayuqamta aren qunukekacaarluta.",
        "translation": "Then we tried to go to school, oh my, our parents were very reluctant to let us go."
    },
    "10": {
        "startTime": 62.195,
        "endTime": 65.19,
        "transcript": "Angurrluk' elitnauryaasqevkenata.",
        "translation": "They told us not to go to school under any circumstances."
    },
    "11": {
        "startTime": 65.19,
        "endTime": 74.48,
        "transcript": "Tamakut camek tua-i akusrarrnarqelriamek ayagnirniluki. Maa-i tua-i ungacautnguniluki tamakut elitnaurviit.",
        "translation": "They said that those were starting some kind of unacceptable behavior. They said those schools [?made them soft]."
    },
    "12": {
        "startTime": 75.17,
        "endTime": 78.69,
        "transcript": "Alingnaqkacagarluteng tua-i tuani pillemteńi.",
        "translation": "They were very scary when we did it then."
    },
    "13": {
        "startTime": 78.695,
        "endTime": 86.65,
        "transcript": "Inerquangraitkut, elitnauryaryaaqerraarlua-ll' wii ataucirqumek tua-i paq'ercaaqerraarlua...",
        "translation": "Though they admonished us, and after I had gone to school, after I had checked them once..."
    },
    "14": {
        "startTime": 86.65,
        "endTime": 89.04,
        "transcript": "Wait, tauna igtuq.",
        "translation": "Wait, that fell."
    },
    "15": {
        "startTime": 94.43,
        "endTime": 96.52,
        "transcript": "Aipaqlian?",
        "translation": "Are you a couple?"
    },
    "16": {
        "startTime": 97.24,
        "endTime": 99.86,
        "transcript": "Qastussiyaallemta pillia?",
        "translation": "Was it because we were too loud?"
    },
    "17": {
        "startTime": 99.865,
        "endTime": 101.065,
        "transcript": "Nuu.",
        "translation": "No."
    },
    "18": {
        "startTime": 103.54,
        "endTime": 109.86,
        "transcript": "Tua-i-llu elitnauryaryaaqerraarluta uitasqeńgatkut uterrluta tua-i.",
        "translation": "Then after we had gone to school, we went home since they told us to stay."
    },
    "19": {
        "startTime": 109.865,
        "endTime": 117.315,
        "transcript": "Makut-wa tua-i qanerturalriit, makut-gguq elitnaurviit arenqiatut.",
        "translation": "These people kept saying that these schools are faulty."
    },
    "20": {
        "startTime": 117.665,
        "endTime": 121.175,
        "transcript": "Avani tua-i iqugglungqertut akusrarr[luteng].",
        "translation": "Over there, they have a bad mischievous result."
    },
    "21": {
        "startTime": 121.175,
        "endTime": 131.725,
        "transcript": "Usviiruciiqut-gguq avani yaaqvaarni tua-i callerkameggnek umyuarteqenrirluteng mat'umek waten akusrarutnek taitengkata tua-i.",
        "translation": "They said that they would become foolish far in the future, not thinking about what they should be doing when they start bringing things that cause mischief."
    },
    "22": {
        "startTime": 132.905,
        "endTime": 139.495,
        "transcript": "Tua-i elitnaurpek'nata makut tau͡gaam ayagyuarluut tua-i irniaput-llu elitnaungluteng.",
        "translation": "We didn't go to school, but our poor young people and our children are starting to go to school."
    },
    "23": {
        "startTime": 139.495,
        "endTime": 143.515,
        "transcript": "Cat nallunringluku tua-i igautaqluta-llu.",
        "translation": "They're finding out about things and they write about us."
    },
    "24": {
        "startTime": 144.44,
        "endTime": 150.48,
        "transcript": "Tamakut tamaa-i Kass'at tuaten, qaillun-llu Kass'anek nangciksailnganateng.",
        "translation": "The Caucasians have done that, and they didn't seem to physically abuse any Caucasians."
    },
    "25": {
        "startTime": 150.485,
        "endTime": 156.605,
        "transcript": "Tau͡gaam tamakut angalkut-llu caliarit tamakut tuaten ayuqellruluteng.",
        "translation": "The work of those shamans were also like that."
    },
    "26": {
        "startTime": 157.64,
        "endTime": 162.82,
        "transcript": "Anglanitekluki tamakut piaqluki yuut umyuarrliqngameng tua-i.",
        "translation": "People have started having fun about those people they have malicious intent."
    },
    "27": {
        "startTime": 162.825,
        "endTime": 176.115,
        "transcript": "Man'a-w' call' akuliitni qanruyuterugaita, imkut qanrutestemta akuliitni piyulria qanruyutem tua-i ilakluku ciknayaraq-gguq man'a.",
        "translation": "And this, among their many pieces of traditional wisdom, among those who wanted to speak to us, they say that jealousy is part of traditional wisdom."
    },
    "28": {
        "startTime": 177.015,
        "endTime": 186.425,
        "transcript": "Yuk-gguq elluarrluni-llu yuungnaqu'urlulria ciknakluku imna angalkum ciknatarlim",
        "translation": "They say that a jealous shaman would be jealous of a person who is living a good life"
    },
    "29": {
        "startTime": 186.765,
        "endTime": 195.715,
        "transcript": "Pinrillugcetaarluku picuirucetaqluku wall' tukuuyulallrat man'a navgaqluku elluarrluteng yuuqataryaaqellret.",
        "translation": "They place curses on them to make them bad hunters, or they destroy the riches of one who had been going to live well."
    },
    "30": {
        "startTime": 195.715,
        "endTime": 198.635,
        "transcript": "Umyuarrliqluteng tamakut cakneq.",
        "translation": "Those have great malicious intent."
    },
    "31": {
        "startTime": 199.07,
        "endTime": 205.79,
        "transcript": "Tua-i-llu cali qanruyutet makut",
        "translation": "Then, these pieces of traditional wisdom"
    },
    "32": {
        "startTime": 206.345,
        "endTime": 217.26,
        "transcript": "Ilameng-gguq akuliit ik'ikengraitkut, tua-i qessamkaukluta-ll' ayagyuarlurni nasaurlulle'rni maani",
        "translation": "They said that though they despise us among our peers, and they say that we poor young people, girls here, are lazy"
    },
    "33": {
        "startTime": 217.26,
        "endTime": 225.32,
        "transcript": "Unugmi-llu anairucarallruama-ll' wii, unugmi-llu tan'geriaqan anenermek taq'laama",
        "translation": "And because I wouldn't go out at night, and I would stop going out at night when it got dark"
    },
    "34": {
        "startTime": 226.785,
        "endTime": 234.375,
        "transcript": "Akeqnerrluggnauraatnga makut qessamkaukuma tua-i waten kaigasteńguciqnilua",
        "translation": "They would intimidate me, saying that if I am lazy that I will be a beggar liek this"
    },
    "35": {
        "startTime": 235.305,
        "endTime": 245.095,
        "transcript": "Picurlautek'larciqniluku-ll' tamana qessamkaulua pirraarlua ilanka [?] ayuqniam ugaani.",
        "translation": "And they said that it would bring me to misfortune after I was lazy, [?] my family because of my desire to [have things]."
    },
    "36": {
        "startTime": 248.855,
        "endTime": 254.965,
        "transcript": "Tau͡gaam tua-i tuaten qanrutaqluta makut wani qanqegcaarautestema.",
        "translation": "But those who taught us well would tell us that."
    },
    "37": {
        "startTime": 254.965,
        "endTime": 267.705,
        "transcript": "Ilamta akuliitni-ll' ellalkartevkenata, imumek [?]tevkenata, murilkevlacagpek'nata, usviitevkenata ilamta akuliitni.",
        "translation": "And they told us not to misbehave among our peers, not to [?], not to be inattentive, not to act foolish among our peers."
    },
    "38": {
        "startTime": 269.44,
        "endTime": 277.14,
        "transcript": "Maktaqameng tua-i qanruqu'urnauraitkut, \"Elpeci-ll' maa-i ayagyuani irniangekuvci-gguq",
        "translation": "When they got up, they would always tell us, \"When you young people have children too"
    },
    "39": {
        "startTime": 277.145,
        "endTime": 289.055,
        "transcript": "\"Irniarci-gguq mikelnguungalnge'rmi, wall' pilukuvceńi camek inerququvciu, 'Kitak' at' ilavet piqaqatgen qimagaqluki ingluliuteng.'\"",
        "translation": "\"Even though your child seems like a child, or if you admonish them when you put on their skin boots, 'Now, if your peers do anything to you, run away [?].'\""
    },
    "40": {
        "startTime": 289.055,
        "endTime": 291.03,
        "transcript": "Atam-gguq cumikeyagatuut.",
        "translation": "They say that they pay attention."
    },
    "41": {
        "startTime": 291.03,
        "endTime": 300.5,
        "transcript": "Tua-i-gguq maa-i makut maa-i ciulirnemta makut tamana ellangeqarraallermeggni niitellerteng tua-i pikluku tua-i.",
        "translation": "They say that what these elders of ours heard when they were growing up are theirs."
    },
    "42": {
        "startTime": 304.97,
        "endTime": 312.83,
        "transcript": "Maa-i tua-i tamana umyuaqaqamku qunukelalqa-llu tamana akusrangciqniluki avani",
        "translation": "When I remember that now, what I didn't want, that they would become mischievous in the future"
    },
    "43": {
        "startTime": 313.445,
        "endTime": 319.935,
        "transcript": "Qitevcuilama-llu qitevtellrit-llu niicuilamki umyuaqluki.",
        "translation": "And since I don't speak English and don't hear them speaking English, I remember them."
    },
    "44": {
        "startTime": 319.935,
        "endTime": 332.125,
        "transcript": "Irniangamegnuk-ll' aipangamegnuk, aipaput kenekluki pisqessaaqaqluki.",
        "translation": "And when we had children and got married, they told us to love our spouses."
    },
    "45": {
        "startTime": 332.825,
        "endTime": 336.94,
        "transcript": "Uiput cumikluki, allaliuqsaunata-llu.",
        "translation": "We should pay attention to our husbands, and never be unfaithful."
    },
    "46": {
        "startTime": 336.94,
        "endTime": 344.87,
        "transcript": "Uimta-llu nalluatni arnaurlulriani wangkuta ayagallerkartuyarrluta",
        "translation": "And if we women go to [other men] without our husbands' knowledge"
    },
    "47": {
        "startTime": 344.87,
        "endTime": 350.2,
        "transcript": "Kiituani-gguq taum uimta pikenrilkiinek qingangaqluta-gguq.",
        "translation": "They said that eventually, we would become pregnant with a child that is not our husbands'."
    },
    "48": {
        "startTime": 350.2,
        "endTime": 361.38,
        "transcript": "Imkut maaten tamaani ellangeqarraallemteńi qanrutaqamegtekut ikiu͡kacagarluku ca ikuggluku qanrutnauraitkut.",
        "translation": "Back when we were growing up, we realized that when they spoke to us, they would tell us of unacceptable things [?] them."
    },
    "49": {
        "startTime": 361.385,
        "endTime": 367.5,
        "transcript": "Tangvagluta-ll' piaqatkut waten umyuarteqsaaqnaurtukut wangkuta niicugnilriani:",
        "translation": "And when they did that watching us, we who were listening would think this:"
    },
    "50": {
        "startTime": 367.5,
        "endTime": 378.08,
        "transcript": "\"Aling ik'um-am cunaw' nallunrilkiikut. Tangellrukiikut.\" Tuar tang nallunritkacagarluta ilumun tangellruluta pilaqaitkut.",
        "translation": "\"Oh my, that person apparently knows us. (S)he saw us.\" It seemed that they knew us very well, like they had truly seen us."
    },
    "51": {
        "startTime": 379.255,
        "endTime": 391.91,
        "transcript": "Cunaw' tamakut qanruciyupialriit ircaqurteng cairluku ellait atullmeggnek assirluki yuk agesqelluku qanruturlularyaaqellinikaitkut.",
        "translation": "It turned out that those who really wanted to speak to us emptied their hearts of what they had experiences, telling us so that a person would do well."
    },
    "52": {
        "startTime": 391.91,
        "endTime": 399.9,
        "transcript": "Irniau͡rluput-llu waten makut irniaqsagutaqamteki angurrluk' tua-i agutevkenaki",
        "translation": "And our poor children, when we have children, they said never to bring them [to others' houses]"
    },
    "53": {
        "startTime": 399.9,
        "endTime": 403.85,
        "transcript": "Tass'uqluki-ll' enenun allanun ceńirtaaruqu'ur[pek'naki].",
        "translation": "And do not hold their hands to have them visit other houses."
    },
    "54": {
        "startTime": 403.85,
        "endTime": 406.27,
        "transcript": "Atam-gguq asriurturlurniartut.",
        "translation": "They said they'd become mischievous."
    },
    "55": {
        "startTime": 406.275,
        "endTime": 411.085,
        "transcript": "Ikiurlullrat man'a arrsaurlullerput ilalqerluku-gguq atam.",
        "translation": "They said that their unacceptable behavior would exacerbate our poverty."
    },
    "56": {
        "startTime": 411.085,
        "endTime": 419.52,
        "transcript": "Aanaulriami wani enem nayurtiini, una-wa-gguq aatavut ayagalria pikangengnaqluta",
        "translation": "A mother who looks after the house, and the father who travels for what we need"
    },
    "57": {
        "startTime": 419.52,
        "endTime": 426.87,
        "transcript": "Pitarra'urlui-gguq tekitaqan quyatekluki ciuniurluki arnaulriani.",
        "translation": "They said that we women should be thankful for whatever he catches when he arrives."
    },
    "58": {
        "startTime": 427.63,
        "endTime": 437.13,
        "transcript": "Wall' akirrarmek unangekan qenngevkenata wangkuta arnani taqmakegciyugluta, wall' camek cap'akiqegciyugluta",
        "translation": "Or if he earns a little money, we women should not be angry wanting beautiful dresses, or something like beautiful shoes"
    },
    "59": {
        "startTime": 437.135,
        "endTime": 442.795,
        "transcript": "Aturaqegciamta-gguq tua-i pikarciaritnek maa-i nangerngiimta.",
        "translation": "Because, they said, that we stand here with good clothes that they've gotten us."
    },
    "60": {
        "startTime": 443.03,
        "endTime": 454.3,
        "transcript": "Tamakut-gguq navguutekait taum aipamteńun tamakut unangkengarait, uirlumta unangkengarait.",
        "translation": "They say that those destroy our spouses, what they have earned, what our poor husbands have earned."
    },
    "61": {
        "startTime": 454.74,
        "endTime": 460.22,
        "transcript": "Munarulluki-gguq munarcallrani tauna aipa'urlurput uqiskirluki.",
        "translation": "They said that we should work dextrously with them as our spouse worked dextrously distributing seal."
    },
    "62": {
        "startTime": 460.225,
        "endTime": 463.98,
        "transcript": "Tamakut tamaa-i anglatekevkenaki-gguq.",
        "translation": "They said not to treat those lightly."
    },
    "63": {
        "startTime": 463.98,
        "endTime": 467.38,
        "transcript": "Akingutaurlui tegulerulluta ayagpek'nata.",
        "translation": "We should not take his heard earned money and go."
    },
    "64": {
        "startTime": 467.385,
        "endTime": 474.545,
        "transcript": "Avani-ll' ayainanemteńi canun akusrarrnarqelrianun tekiskumta wall' mer'aluta wall' canun",
        "translation": "And as we go, if we come across things that bring mischief, or we drink, or other things"
    },
    "65": {
        "startTime": 475.32,
        "endTime": 485.22,
        "transcript": "Inerqurluta tua-i tamalkuitnek tamakunek aarnarqelrianek, irniamta-ll' takuatni tuaten ayuqesqevkenata. Alerquaciqaput-gguq.",
        "translation": "They admonished us against all of those dangerous things, and that we shouldn't do that in front of our children. They said that we would teach them."
    },
    "66": {
        "startTime": 485.225,
        "endTime": 497.245,
        "transcript": "Cunaw' imna anguyagteńun ayagangaqameng tan'gaurlurugaungameng-ll' irniapuk tua-i umyuaq una navgurluku yuungaqluta mer'ayullermegteggun maaggun.",
        "translation": "it turned out that when they start going into military service, since we have a lot of male children, we start living destroying our mental health because they abuse alcohol."
    },
    "67": {
        "startTime": 497.98,
        "endTime": 506.28,
        "transcript": "Tua-i tuaten tau͡gaam ilalqerpek'nani yuk yuurluqili mat'um nalliini.",
        "translation": "However, may a person live life without exacerbating things like that in these days."
    },
    "68": {
        "startTime": 506.305,
        "endTime": 517.635,
        "transcript": "Tamana-llu tamaa-i akerrneqlugutek'lallrat, akusrangkumta-gguq tamakut angayuqamta qanrutestemta ciulirnemta qanrutaqamegtekut",
        "translation": "And their warning of danger, that if we start being mischievous when our parents who teach us, when our elders teach us"
    },
    "69": {
        "startTime": 517.635,
        "endTime": 522.065,
        "transcript": "Akusrangkumta-gguq camek elpek'ngaarulluta",
        "translation": "If we start being mischievous without thought for anything"
    },
    "70": {
        "startTime": 522.065,
        "endTime": 531.625,
        "transcript": "Qanrutestevut cumikenrirluku alerquastevut, elluarrluta yuusqelluta aviranaunata ilamta akuliitni",
        "translation": "Stop paying attention to those who teach and instruct us, telling us to live well without hindering those among us"
    },
    "71": {
        "startTime": 532.16,
        "endTime": 537.0,
        "transcript": "Tau͡gaam-gguq assirluta tangniqluta enemteńi aqumluta.",
        "translation": "Instead, they said that we should be good, pleasant to be seen sitting in our homes."
    },
    "72": {
        "startTime": 537.005,
        "endTime": 541.84,
        "transcript": "Enevut-gguq uitanqegcinaqniartuq.",
        "translation": "So, they said, that our house would be peaceful."
    },
    "73": {
        "startTime": 541.84,
        "endTime": 551.66,
        "transcript": "Allaneruaraam-llu nanikualriim itervikekakut uitanqegcivkangnaqluku, im'uvkenata akusrartevkenata yuukumta.",
        "translation": "And if some guest who feels helpless comes in, try to make them feel at east, if we, you know, do not live mischievously."
    },
    "74": {
        "startTime": 551.835,
        "endTime": 562.685,
        "transcript": "Tua-i tuaten qanraqata piyugyaaqengramta amta-llu tua-i iliini canun tekitengaqluta tua-i",
        "translation": "When they said that, though we wanted to, yet we would sometimes come across things"
    },
    "75": {
        "startTime": 563.515,
        "endTime": 567.535,
        "transcript": "Assiryugyaaqellerput man'a ukatairluku.",
        "translation": "We missed our desire to be good."
    },
    "76": {
        "startTime": 567.921,
        "endTime": 581.543,
        "transcript": "Makut-llu maa-i waten makutgun qanruciarkanek kepqengata ayagyuat makut wani kinguqliput maa-i mat'um nalliini yuut amlleriameng",
        "translation": "And these days, since these young people, our descendants, are now in great need of teachers these days because there's not a lot of people"
    },
    "77": {
        "startTime": 581.769,
        "endTime": 588.069,
        "transcript": "Alerquatmek niicungata, tamana tang tua-i capqerqelaqeka.",
        "translation": "Since they want to hear instructions, I find that daunting."
    },
    "78": {
        "startTime": 588.281,
        "endTime": 597.17,
        "transcript": "Angliriluta tua-i waten niicugniarkauyaaqekput qanruyutiit elluarrluku",
        "translation": "We grew up, needing to listen to their traditional wisdom well like this"
    },
    "79": {
        "startTime": 597.186,
        "endTime": 608.019,
        "transcript": "Imkut ak'a ayagnengellruyaaqngata ggun KYUK-kun qanelriit, imkut arnat-llu alerquagiluteng.",
        "translation": "Because they've already strated speaking through KYUK here, and those women instruct."
    },
    "80": {
        "startTime": 608.028,
        "endTime": 619.528,
        "transcript": "Tamakut-llu tamaa-i arnat uingit tuar caunrilkellermegteggun ciisqurrilitaqluki tamaaggun",
        "translation": "And those women, it seems that through their disregard for their husbands, they're like knee guards through that"
    },
    "81": {
        "startTime": 619.539,
        "endTime": 625.995,
        "transcript": "Ayuqenrilngurnek-llu irniangeksaunata, uirlurput-wa una nakmiillarput.",
        "translation": "And we didn't have different children [from different men], with our very own husband here."
    },
    "82": {
        "startTime": 626.451,
        "endTime": 635.196,
        "transcript": "Aipamta-gguq tau͡gaam tamakunek irniarinek irniarluta, canek allatarnek ilayuunaki.",
        "translation": "They said that we only had children from our spouse, without adding any from others."
    },
    "83": {
        "startTime": 635.207,
        "endTime": 637.796,
        "transcript": "Tangniqpiarluteng-gguq.",
        "translation": "They said they were beautiful."
    },
    "84": {
        "startTime": 638.309,
        "endTime": 643.064,
        "transcript": "Aren ayuqniarluryaaqnaurtua, aling arenqiapaa-ll'.",
        "translation": "Oh my, I would want that, oh my goodness."
    },
    "85": {
        "startTime": 643.415,
        "endTime": 650.882,
        "transcript": "Waniw' tua-i nallumteńi-ll' tua-i tayima tua-i qingircetnayukluta.",
        "translation": "Here, we would be scared that we would be impregnated without our knowledge."
    },
    "86": {
        "startTime": 650.899,
        "endTime": 658.31,
        "transcript": "Ayagyuarluta-ll' qingircetlerkaq tua-i alingnaqkacagarluni, mikelngurmek alairillerpuk.",
        "translation": "And it was very scary to become pregnant at a young age, to bring forth a child."
    },
    "87": {
        "startTime": 658.311,
        "endTime": 663.844,
        "transcript": "Atailnguut tallurnaqkacagarluteng-gguq. Inerquutngullruyaaqluni.",
        "translation": "They said illegitimate are embarrassing. It was an admonishment."
    },
    "88": {
        "startTime": 663.852,
        "endTime": 670.263,
        "transcript": "Maa-i tamatuullinilria akusrangllerkaatnek qanlallrat imkut au͡gkut ciuliamta.",
        "translation": "Apprently, this was the mischief that our elders back then would talk about."
    },
    "89": {
        "startTime": 671.148,
        "endTime": 682.747,
        "transcript": "Tamana tamaa-i alerquuterpaksaaqekiit maa-i makut tua-i Kass'at maa-i assipiat. Aling niitniqpiat. Ungaqtarnaqpiat Kass'at.",
        "translation": "That import Western instruction these days is very good. Oh my, they're so nice to hear. Caucasians make us feel nice."
    },
    "90": {
        "startTime": 683.694,
        "endTime": 695.45,
        "transcript": "Tangvaqamta tangercetaanek-llu tangvagaqamta canek-llu au͡gkut inerciigalnguut arnat-llu kap'urluraqaceteng qaillurayak elli'irrnaurtut.",
        "translation": "When we watch things on TV, when they inject people who are rowdy, including women, they would become very abnormal."
    },
    "91": {
        "startTime": 695.466,
        "endTime": 701.688,
        "transcript": "Unaqsaqerrluteng camek tua-i tuar tang eyautairtelalriit wangni.",
        "translation": "They become limp [sedated], and it seems they have no more [?] to me."
    },
    "92": {
        "startTime": 701.95,
        "endTime": 710.861,
        "transcript": "Cam im' inerciigalnguum tekiskateng tua-i piningnaqluteng pisciigaciiqnganateng.",
        "translation": "If some rowdy person comes upon them, it seems they wouldn't be able to hold up with their strength."
    },
    "93": {
        "startTime": 710.877,
        "endTime": 719.599,
        "transcript": "Inerquutnek makut wani assiitellriit atuqsaileng'erpeciki ayagyuani.",
        "translation": "You young people shouldn't do bad things that are admonished against."
    },
    "94": {
        "startTime": 720.503,
        "endTime": 724.42,
        "transcript": "Maligqurassiyaagpek'naki Kass'at makut pisqutait",
        "translation": "Do not follow what the West tells you to do too much"
    },
    "95": {
        "startTime": 724.425,
        "endTime": 732.458,
        "transcript": "Canek tua-i makut puyurtull'e'rnek-llu canek pinglarniitki iqugglugningqeńilaitkit tamakut.",
        "translation": "Also because they say these things, including marijuana, have substances and that they do not end well."
    },
    "96": {
        "startTime": 732.47,
        "endTime": 734.392,
        "transcript": "Tamakut atuqsailengraata.",
        "translation": "You shouldn't use them."
    },
    "97": {
        "startTime": 734.407,
        "endTime": 737.707,
        "transcript": "Waten tau͡gaam yuuqallerput tang tua-i ikgetlinilria.",
        "translation": "Our life here is short."
    },
    "98": {
        "startTime": 737.721,
        "endTime": 747.71,
        "transcript": "Una wani ayagyuallerput, ellangellerput canimelngat'laryaaqellria, amta-ll' waten pinialiluta carpagciigaliluta.",
        "translation": "Our youth and our time growing up seems close, yet we become weak like this and can't do strenuous things."
    },
    "99": {
        "startTime": 747.721,
        "endTime": 754.643,
        "transcript": "Taumek mulngakluci tuaten tamakut assiiterrlainaat maligtevkenaki.",
        "translation": "That's why you should be careful like that, not following only bad things."
    },
    "100": {
        "startTime": 754.645,
        "endTime": 763.334,
        "transcript": "Cavvliurluci yuungnaqluci akingengnaqluci pikuvci tengruluci quyanarqekaca'arciquci.",
        "translation": "If you live life doing housework, making money with enthusiasm, it will make us grateful."
    },
    "101": {
        "startTime": 763.35,
        "endTime": 771.328,
        "transcript": "But, use your money for yourselves, your houses, to help you with what you need.",
        "translation": "But, use your money for yourselves, your houses, to help you with what you need."
    },
    "102": {
        "startTime": 772.011,
        "endTime": 781.9,
        "transcript": "Wiinga-ll' tua-i waniwa qitevvneq-llu nalluamku, qaill' ucuryagutakevkenaku atuyuilamku tua-i.",
        "translation": "And now, since I don't know how to speak English, I don't hold it in high regard because I don't use it."
    },
    "103": {
        "startTime": 782.914,
        "endTime": 794.292,
        "transcript": "Pisqeqapigtaqatnga tau͡gaam ik'um-ll' aiparma maliklua camek, maligglua camek tua-i tegutaqlua una-kiq qaill' tunllerkaa nalluk'acagaamku.",
        "translation": "Only when they really want me to, my spouse across there goes with me, he goes with me and I take something, because I have no idea how to give it."
    },
    "104": {
        "startTime": 794.43,
        "endTime": 800.641,
        "transcript": "Quyanaqkacagarluni tua-i quyaaqlua nallucimnek uitanqegcilua uitalaama.",
        "translation": "I am thankful that I don't know because I stay in peace."
    },
    "105": {
        "startTime": 801.141,
        "endTime": 809.252,
        "transcript": "Imkut tua-i carrarmek qanlaata tangvak'ngapuk, tayim' amlleriyaaqellilriit-llu qanelpuk.",
        "translation": "Because the ones we watch say little, but we have probably said a lot by now."
    },
    "106": {
        "startTime": 810.046,
        "endTime": 817.268,
        "transcript": "Waten-qaa pitakumegnuk amlleriksaitut tayima qanrumallerpuk ava-i?",
        "translation": "If this is all for us, have what we said not become a lot?"
    },
    "107": {
        "startTime": 817.474,
        "endTime": 818.596,
        "transcript": "Tua-i?",
        "translation": "Is that all?"
    },
    "108": {
        "startTime": 818.605,
        "endTime": 821.738,
        "transcript": "Tua-i waten pitayugyaaqelrianga.",
        "translation": "This is all I want [to say]."
    }
};